var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement } from "lit/decorators.js";
import { css, html, LitElement } from "lit";
import { defaults, secondaryOnSurfaceColor, secondarySurfaceContainerColor } from "../style";
let ExceptionFrameComponent = class ExceptionFrameComponent extends LitElement {
    render() {
        return html `
            <h3>
                <slot name="title"></slot>
            </h3>
            <p>
                <slot></slot>
            </p>
        `;
    }
};
ExceptionFrameComponent.styles = [defaults, css `
        :host {
          display: block;
          padding: 20px;
          border-radius: 10px;
          background-color: ${secondarySurfaceContainerColor};
          color: ${secondaryOnSurfaceColor};
          font-size: 14px;
          width: 400px;
        }

      h3{
        margin-top: 0;
      }
      
    `];
ExceptionFrameComponent = __decorate([
    customElement('tc-exception-card')
], ExceptionFrameComponent);
export { ExceptionFrameComponent };
//# sourceMappingURL=ExceptionCard.js.map